import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { pageTitle } from "@/components/document-title";
import { CleaningPage } from "@/features/tasks/pages/cleaning-page/cleaning-page";
import { cleaningsFilterSchema } from "@/features/tasks/schemas/cleanings-filter.schema";

export const Route = createFileRoute("/_authenticated/admin/tasks/cleaning/")({
	head: () => pageTitle("Cleaning Tasks"),
	component: CleaningPage,
	validateSearch: zodValidator(cleaningsFilterSchema),
});
